import { render, staticRenderFns } from "./RentPage.vue?vue&type=template&id=bb3a59f6&scoped=true&"
import script from "./RentPage.vue?vue&type=script&lang=js&"
export * from "./RentPage.vue?vue&type=script&lang=js&"
import style0 from "./RentPage.vue?vue&type=style&index=0&id=bb3a59f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a59f6",
  null
  
)

export default component.exports